/**
 * Format a numeric or string price to "€ XXX.XX" Euro display.
 * Falls back to the raw input if it is not a parsable number.
 */
export const formatPrice = (price) => {
  if (price === null || price === undefined || price === "") return "";
  const n = parseFloat(String(price).replace(",", "."));
  if (isNaN(n)) return `€ ${price}`;
  return `€ ${n.toFixed(2)}`;
};
